





































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import { required, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class AddSetpointDialog extends Vue {
  @Prop({ default: true }) value: Boolean;
  @Prop({}) selectedProduct: any;
  @Prop({}) setPointOptionsData: any;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  setPoint = "";
  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  setPointList = [];

  mounted() {}

  async onSave() {
    const isValid = await this.observer.validate();
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$emit("addSetPointCompleted", this.setPoint);
    this.show = false;
  }

  onClose() {
    this.$emit("onClose", "closed");
  }

  @Watch("show")
  onShowChanged(value: string, oldValue: string) {
    if (!value) this.onClose();
  }
}
